import React from 'react';
const MailIconAlt = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"
      fill="none"
    />
    <rect x="7" y="9" width="15" height="11" rx="2" fill="white" />
    <rect x="8" y="10" width="16" height="12" rx="1" stroke="#A0A4C0" strokeWidth="2" />
    <path
      d="M11 13L15.4855 15.6913C15.8022 15.8813 16.1978 15.8813 16.5145 15.6913L21 13"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default MailIconAlt;
